import React, { useState, useContext, useEffect } from "react";
import PhHeader from "../components/photographer/PhHeader";
import AppFooter from "../components/AppFooter";
import UserContext from "../contexts/UserContext";

import Utils from "./../Utils";

const PhLayout = ({ children }) => {

    const { userData } = useContext(UserContext);

    useEffect(() => {
        if (userData == null || userData == undefined || userData == false) {
            console.log(process.env.PUBLIC_URL + '/');
            window.location.href = process.env.PUBLIC_URL + '/';
        }
    }, [userData]);

    return (
        <div className="ftbottom">
            <PhHeader />
            {children}
            <AppFooter />
        </div>
    )
}
export default PhLayout;
